import { POST_ALL_URLS, RESET_ALL_URLS } from "../../constant/ActionType";

export default function UrlReducer(
  state = {
    urlsenderTemplates: [], // This will reset
    statusCode: null, // This will remain unchanged
  },
  action
) {
  switch (action.type) {
    case POST_ALL_URLS:
      return {
        ...state,
        urlsenderTemplates: action, // Update with new data
        statusCode: action.status,
      };

    case RESET_ALL_URLS:
      return {
        ...state,
        urlsenderTemplates: false, // Reset only urlsenderTemplates
      };

    default:
      return state;
  }
}
